import AccordionComponent from './AccordionComponent.vue';
import CertifiedCompany from './CertifiedCompany.vue';
import LogoMasonryGrid from './LogoMasonryGrid.vue';
import StandardsSearch from './StandardsSearch.vue';
import StandardsTable from './StandardsTable.vue';
import StandardsCount from './StandardsCount.vue';
import GoogleMap from './GoogleMap.vue';
import MembersMap from './MembersMap.vue';
import MembersList from './MembersList.vue';
import MembersAZSelect from './MembersAZSelect.vue';
import SearchTrigger from './SearchTrigger';
import Search from './Search';
import SubNav from './SubNav';
import SubSubNav from './SubSubNav';
import MainMenu from './MainMenu';
import MainMenuFetcher from './MainMenuFetcher';
import Cards from './Cards';
import GlideSlide from './GlideSlide';
import ShowHide from './ShowHide';
import SweetAlert from './SweetAlert';
import Popup from './Popup';
import GoldCertificationHolders from './gold-certification-holders/GoldCertificationHolders.vue';
import ErgonomicsExcellenceHolders from './ergonomics-excellence-holders/ErgonomicsExcellenceHolders.vue';
import PredictiveSearch from './PredictiveSearch.vue';
import RestrictedContentImagePlaceholder from './RestrictedContentImagePlaceholder.vue';

Vue.component("accordion", AccordionComponent);
Vue.component("certified-company", CertifiedCompany);
Vue.component("logo-masonry-grid", LogoMasonryGrid);
Vue.component("standards-search", StandardsSearch);
Vue.component("standards-table", StandardsTable);
Vue.component("standards-count", StandardsCount);
Vue.component("google-map", GoogleMap);
Vue.component("members-map", MembersMap);
Vue.component("members-list", MembersList);
Vue.component("members-a-z-select", MembersAZSelect);
Vue.component("search-trigger", SearchTrigger);
Vue.component("search-view", Search);
Vue.component("sub-nav", SubNav);
Vue.component("sub-sub-nav", SubSubNav);
Vue.component("main-menu", MainMenu);
Vue.component("main-menu-fetcher", MainMenuFetcher);
Vue.component("cards", Cards);
Vue.component("glide-slide", GlideSlide);
Vue.component("show-hide", ShowHide);
Vue.component("sweet-alert", SweetAlert);
Vue.component("popup", Popup);
Vue.component("gold-certification-holders", GoldCertificationHolders);
Vue.component("ergonomics-excellence-holders", ErgonomicsExcellenceHolders);
Vue.component("predictive-search", PredictiveSearch);
Vue.component("restricted-content-image-placeholder", RestrictedContentImagePlaceholder);

import PortalVue from "portal-vue";
Vue.use(PortalVue);

import vClickOutside from "v-click-outside";
Vue.use(vClickOutside);
